import axios from "axios";

export const fetchMyProductAccess = async (
  apiUrl = process.env.REACT_APP_API2_URL
) => {
  const { data } = await axios.get(`${apiUrl}/v3/my/product-access`);
  return data || [];
};
